import { render, staticRenderFns } from "./doughnat-legend-dynamic.vue?vue&type=template&id=d2ccfef0&"
import script from "./doughnat-legend-dynamic.vue?vue&type=script&lang=js&"
export * from "./doughnat-legend-dynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "doughnat-legend-dynamic.vue"
export default component.exports